export default ({ request }) => ({
  mrpQualityIssuesListApi(data = {}) {
    return request({
      url: '/factory/mrp/quality/issues/list',
      method: 'post',
      data
    })
  },
  mrpQualityIssuesPageListApi(data = {}) {
    return request({
      url: '/factory/mrp/quality/issues/pageList',
      method: 'post',
      data
    })
  },
  mrpQualityIssuesSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/quality/issues/save',
      method: 'post',
      data
    })
  },
  mrpQualityIssuesDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/quality/issues/detail',
      method: 'post',
      data
    })
  },
  mrpQualityIssuesDelApi(data = {}) {
    return request({
      url: '/factory/mrp/quality/issues/del',
      method: 'post',
      data
    })
  },
  mrpQualityIssuesGroupApi(data = {}) {
    return request({
      url: '/factory/mrp/quality/issues/issuesGroup/list',
      method: 'post',
      data
    })
  },
})
